import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import logo from "../../assets/images/differentiallogo.png";
import Helper from '../helper';
import Auth from '../services/auth.service';


export default function FormHeader() {
    const [sidebarMenu, setSidebarMenu] = useState(false);
    const navigate = useNavigate();

    const sidebarOpen = () => {
        setSidebarMenu(true)
    }

    const sidebarClose = () => {
        setSidebarMenu(false)
    }

    const handleClick = e => {
        e.preventDefault();

        localStorage.removeItem('user');
        localStorage.removeItem('formCount');
        localStorage.setItem('LOG_MSG', 'You are successfully logged out.');
        window.location.href = '/';
    }

    return (
        <header className='header-section'>
            <div className='container'>
                <nav className="navbar navbar-expand-md">
                    <a className="navbar-brand" href="/stepform">
                        <img src={logo} />
                    </a>
                    <div className='hamburger-menu' onClick={sidebarOpen}>
                        <i className="icon fa fa-bars" aria-hidden="true"></i>
                    </div>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav ml-auto mr-4">
                            <li className="nav-item">
                                <a className="nav-link" href="/stepform">Application Details</a>
                            </li>
                            <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-expanded="false">
                                    My Account
                                </a>
                                <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <a onClick={handleClick} className="dropdown-item" href="/">Logout</a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>
            <div className={`mobile-menu ${sidebarMenu ? "active" : ""}`}>
                <div className='d-flex justify-content-between align-items-center'>
                    <a className="navbar-brand px-3 m-0" href="/stepform">
                        <img src={logo} height={35} />
                    </a>
                    <div className='close-btn'>
                        <span onClick={sidebarClose}><i className="fa fa-times" aria-hidden="true"></i></span>
                    </div>
                </div>
                <div className='py-5 menu-wrapper'>
                    <a href="/stepform" className='nav-link'>Application Details</a>
                    <a href="/" className='nav-link'>Logout</a>
                </div>

            </div>
            <div className={`overlay ${sidebarMenu ? "active" : ""}`} onClick={sidebarClose}></div>
        </header>
    )
}
